export const dimensions = {
    widthPerDay: 26, // px
    heightPerSegment: 12, //px
    segmentNameFontSize: 12, // px
};

export const hoverColor = '#01ff46';

export const loadingString = 'loading chronotope data...';

export const errorString = 'error fetching data...';

export const titleString = 'Chronotope Data for';

export const displayFontSize = 1; // rem
